module.exports = __webpack_public_path__ + "static/media/image_case_feige.04cd1515.png";